import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import find from 'lodash/find';
import Color from '../../../styles/colors';
import { Icon } from '../../../icons';

const SelectorLabel = styled.p`
  margin-bottom: 0;
`;

const OuterWrapper = styled.div`
  position: relative;
  font-size: 1rem;
  line-height: 2rem;
  height: 2rem;
  color: white;
  text-transform: uppercase;
  z-index: 10;
  margin-bottom: 2rem;
  font-family: 'ApercuMedium';
`;

const Wrapper = styled.div`
  position: absolute;
  background: black;
  border-radius: 4px;
  width: 20rem;
  padding: 0.4375rem 0.875rem !important;
  box-sizing: border-box;
`;

const SelectedLanguage = styled.a`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  svg {
    width: 1rem;
    height: 1rem;
  }
`;

const LanguageDropdown = styled.ul`
  display: ${props => (props.isOpen ? 'block' : 'none')};
  font-size: inherit !important;
  line-height: inherit !important;
  margin-bottom: 0 !important;
`;

const LanguageItem = styled.li`
  a {
    color: inherit !important;
    display: block;
  }
  ${props =>
    props.isActive &&
    `
    font-weight: bold;
    a {
      color: ${Color.ORANGE} !important;
    }
    `};

  margin-bottom: 0 !important;
  padding: 0 !important;

  &:before {
    content: unset !important;
  }
`;

class LanguageSelector extends Component {
  state = {
    isOpen: false,
  };

  componentDidMount = () => {
    document.addEventListener('click', this.close, true);
  };

  componentWillUnmount = () => {
    document.removeEventListener('click', this.close, true);
  };

  open = () => {
    if (this.state.isOpen) return;
    this.setState({
      isOpen: true,
    });
  };

  close = event => {
    if (!this.state.isOpen) return;
    this.setState({
      isOpen: false,
    });

    event.stopPropagation();
  };

  toggle = () => {
    const wasOpen = this.state.isOpen;
    this.setState({
      isOpen: !wasOpen,
    });
  };

  render() {
    const { isOpen } = this.state;
    const { items, slug } = this.props;
    const current = find(items, { url: `/${slug}` });

    return (
      <React.Fragment>
        <SelectorLabel>Please select your language:</SelectorLabel>
        <OuterWrapper>
          <Wrapper>
            <SelectedLanguage onClick={this.toggle}>
              {current.label}
              <Icon icon="#arrow-down" />
            </SelectedLanguage>
            <LanguageDropdown isOpen={isOpen}>
              {items.map((item, index) => (
                <LanguageItem key={index} isActive={item.url === `/${slug}`}>
                  <a href={item.url}>{item.label}</a>
                </LanguageItem>
              ))}
            </LanguageDropdown>
          </Wrapper>
        </OuterWrapper>
      </React.Fragment>
    );
  }
}

LanguageSelector.propTypes = {
  items: PropTypes.array.isRequired,
  slug: PropTypes.string.isRequired,
};

export default LanguageSelector;



// WEBPACK FOOTER //
// ./src/modules/pages/components/LanguageSelector.js